import { render, staticRenderFns } from "./thisMonthCollect.vue?vue&type=template&id=43c33d38&scoped=true&"
import script from "./thisMonthCollect.vue?vue&type=script&lang=js&"
export * from "./thisMonthCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c33d38",
  null
  
)

export default component.exports